export const NAME = 'basket'
export const SET_BASKET = 'SET_BASKET'
export const SET_TRANSACTION = 'SET_TRANSACTION'
export const SET_RESPONSE = 'SET_RESPONSE'